module.exports = __webpack_public_path__ + "img/d355186.png";